import fetch from '@/api/fetch';

export const updateUserinfo = req =>
  fetch({
    url: '/adminChange/updatePwd',
    method: 'post',
    ...req,
  });

export const updateUserCellphone = req =>
  fetch({
    url: '/adminChange/updatePhone',
    ...req,
  });
export const getVcode = req =>
  fetch({
    url: '/adminChange/getCode',
    ...req,
  });
